<div class="produtos" fxLayout="row">
    <div fxFlex="50" class="pointer" routerLink="/products/presencial">
        <div fxLayout="column" class="produtos-card" fxLayoutAlign="center center" *ngIf="data.secaoProdutosPresenciais.path"
            style="background-image: url('{{storageUrl + data.secaoProdutosPresenciais.path}}');">
            <span class="title">{{data.secaoProdutosPresenciais.titulo}}</span>
            <div fxLayout="column" class="description" fxLayoutAlign="center center">
                <span style="margin-bottom: 50px;">{{data.secaoProdutosPresenciais.conteudo}}</span>
                <app-button [txt]="'SAIBA MAIS'" [fontFamily]="'Montserrat'"
                    [btnClass]="'btn-white explore-aqui-btn-w'"></app-button>
            </div>
        </div>
    </div>
    <div fxFlex="50" class="pointer" routerLink="/products/digital">
        <div fxLayout="column" class="produtos-card" fxLayoutAlign="center center" *ngIf="data.secaoProdutosDigitais.path"
            style="background-image: url('{{storageUrl + data.secaoProdutosDigitais.path}}');">
            <span class="title">{{data.secaoProdutosDigitais.titulo}}</span>
            <div fxLayout="column" class="description" fxLayoutAlign="center center">
                <span style="margin-bottom: 50px;">{{data.secaoProdutosDigitais.conteudo}}</span>
                <app-button [txt]="'SAIBA MAIS'" [fontFamily]="'Montserrat'"
                    [btnClass]="'btn-white explore-aqui-btn-w'"></app-button>
            </div>
        </div>
    </div>
</div>
